import PendingTransactions from './PendingTransactions'

export default PendingTransactions
